var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GalaxyApi } from "@/api";
import { toQuotaUsage } from "@/components/User/DiskUsage/Quota/model";
import { rethrowSimple } from "@/utils/simple-error";
export {} from "@/components/User/DiskUsage/Quota/model";
export function fetchCurrentUserQuotaUsages() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/users/{user_id}/usage", {
            params: { path: { user_id: "current" } },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data.map((usage) => toQuotaUsage(usage));
    });
}
export function fetchCurrentUserQuotaSourceUsage(quotaSourceLabel) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!quotaSourceLabel) {
            quotaSourceLabel = "__null__";
        }
        const { data, error } = yield GalaxyApi().GET("/api/users/{user_id}/usage/{label}", {
            params: { path: { user_id: "current", label: quotaSourceLabel } },
        });
        if (error) {
            rethrowSimple(error);
        }
        if (data === null) {
            return null;
        }
        return toQuotaUsage(data);
    });
}
